export default "__VITE_ASSET__BkHu8vOm__"